export default __webpack_public_path__ + "static/Museo-Sans-500-Italic-59180471dc0461c501572b49912e8565.woff";